import React, { useState, useEffect } from 'react';
import './StatsWidget.css';

const StatsWidget = ({ isVisible }) => {
  const [count, setCount] = useState(10500000);
  const start = 11500000;
  const target = 36450000;
  const duration = 3000000;

  useEffect(() => {
    if (!isVisible) return;
    const intervalTime = 500; 
    const step = 255300;

    const timer = setInterval(() => {
      setCount(prev => {
        const next = prev + step;
        if (next >= target) {
          return start;
        }
        return next;
      });
    }, intervalTime);
    return () => clearInterval(timer);
  }, [isVisible]);

  return (
    <div className={`hud-widget ${isVisible ? 'visible' : ''}`}>
      <div className="hud-chart">
        <svg viewBox="0 0 100 30" className="chart-svg">
          <polyline 
            fill="none" 
            stroke="#00ff88" 
            strokeWidth="2" 
            points="0,25 20,20 40,15 60,20 80,10 100,5"
            className="line-anim"
          />
        </svg>
      </div>
      <div className="hud-content">
        <div className="hud-label">VOS REVENUS</div>
        <div className="hud-amount">{count.toLocaleString('fr-FR').replace(/\u00a0/g, ' ')} F CFA</div>
      </div>
    </div>
  );
};

export default StatsWidget;